<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M35.28 2063.73l352.73 0 0 881.94 2822.3 0 0 -881.94 352.73 0 0 881.94c0,195.8 -156.93,352.8 -352.73,352.8l-2822.3 0c-194,0 -352.73,-157 -352.73,-352.8l0 -881.94 0 0zm1763.88 529.2l978.94 -963.14 -250.47 -248.67 -552.07 550.34 0 -1631.61 -352.8 0 0 1631.61 -550.34 -550.34 -250.47 250.47 977.21 961.34z"/>
  </g>
 </g>
</svg>
